export enum TimelineGridEventPlaceholderCssVars {
  xPosition = '--x-position',
  width = '--width',
}
